import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronGrabberHorizontalToward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-grabber-horizontal-toward"} maskId="square-filled-radius-0-stroke-1-IconChevronGrabberHorizontalToward"><path d="M9.95703 12L5.25 16.707L4.54297 16L8.54297 12L4.54297 8L5.25 7.29297L9.95703 12Z" fill="currentColor"/><path d="M19.457 8L15.457 12L19.457 16L18.75 16.707L14.043 12L18.75 7.29297L19.457 8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronGrabberHorizontalToward;
